import { render, staticRenderFns } from "./LoginCardSet.vue?vue&type=template&id=72efe1f6&scoped=true"
import script from "./LoginCardSet.vue?vue&type=script&lang=ts"
export * from "./LoginCardSet.vue?vue&type=script&lang=ts"
import style0 from "./LoginCardSet.vue?vue&type=style&index=0&id=72efe1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72efe1f6",
  null
  
)

export default component.exports